"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _main = _interopRequireDefault(require("./main.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = {
  arrayObjectList: null,
  //解析组件绑定动作
  buildAction: function buildAction(eventList, el, scope) {
    var config = el.__config__;
    var list = [];
    eventList && eventList.forEach(function (item) {
      //过滤未设置 或 选择无动作
      if (item.isAction && item.method.length > 0 && item.method[0] != 0) {
        if (item.eventName == 'TabClick') {
          list.push("@tab-click='".concat(item.eventName).concat(config.target, "Method").concat(item.method[item.method.length - 1], "'"));
        } else {
          if (el.__config__.tag === 'yl-lc-button') {
            if (scope) {
              list.push("@".concat(_main["default"].charLowerCase(item.eventName), ".native='").concat(item.eventName).concat(config.target, "Method").concat(item.method[item.method.length - 1], "(scope)'"));
            } else {
              list.push("@".concat(_main["default"].charLowerCase(item.eventName), ".native='").concat(item.eventName).concat(config.target, "Method").concat(item.method[item.method.length - 1], "'"));
            }
          } else {
            list.push("@".concat(_main["default"].charLowerCase(item.eventName), "='").concat(item.eventName).concat(config.target, "Method").concat(item.method[item.method.length - 1], "'"));
          }
        }
      }
      ;
      if (!item.isAction && item.body) {
        if (item.eventName == 'TabClick') {
          list.push("@tab-click='".concat(item.eventName).concat(config.target, "Method'"));
        } else {
          if (el.__config__.tag === 'yl-lc-button') {
            if (scope) {
              list.push("@".concat(_main["default"].charLowerCase(item.eventName), ".native='").concat(item.eventName).concat(config.target, "Method(scope)'"));
            } else {
              list.push("@".concat(_main["default"].charLowerCase(item.eventName), ".native='").concat(item.eventName).concat(config.target, "Method'"));
            }
          } else {
            list.push("@".concat(_main["default"].charLowerCase(item.eventName), "='").concat(item.eventName).concat(config.target, "Method'"));
          }
        }
      }
    });
    return list;
  },
  //取公有属性
  publicAttr: function publicAttr(el) {
    var config = el.__config__;
    return {
      tag: config.tag,
      vmodel: config.target,
      ref: config.target,
      style: config.style ? ":style='".concat(JSON.stringify(config.style), "'") : ''
    };
  },
  //创建是否禁用
  disabledStatusAttr: function disabledStatusAttr(el) {
    var config = el.__config__;
    var disabledBody = config.isDisabled.body && config.isDisabled.body.includes('scope') ? _main["default"].replaceChars(config.isDisabled.body) : "source.".concat(_main["default"].replaceChars(config.isDisabled.body));
    var targetDisabled = "".concat(config.isDisabled.isAction ? el.disabled : disabledBody);
    return {
      disabled: "".concat(targetDisabled)
    };
  },
  //创建是否显示
  displayStatusAttr: function displayStatusAttr(el) {
    var config = el.__config__;
    var displayBody = config.tag === 'yl-lc-button' ? el.isShow.body && el.isShow.body.includes('scope') ? _main["default"].replaceChars(el.isShow.body) : "source.".concat(_main["default"].replaceChars(el.isShow.body)) : config.isShow.body && config.isShow.body.includes('scope') ? _main["default"].replaceChars(config.isShow.body) : "source.".concat(_main["default"].replaceChars(config.isShow.body));
    var targetDisplay = config.tag === 'yl-lc-button' ? "".concat(el.isShow.isAction ? el.isShow.status : displayBody) : "".concat(config.isShow.isAction ? config.isShow.status : displayBody);
    return {
      display: "".concat(targetDisplay)
    };
  },
  //解析子级
  buildChildren: function buildChildren(layouts, children, el) {
    var list = [];
    children.forEach(function (item) {
      list.push(layouts[item.__config__.layout] && layouts[item.__config__.layout](item, el));
    });
    return list;
  },
  //获取yl-lc-title标题
  buildYlTitle: function buildYlTitle(el) {
    var config = el.__config__;
    return Object.assign(this.publicAttr(el), {
      title: "".concat(config.target, "Title"),
      disabledBack: el.disabledBack
    });
  },
  //获取yl-searchForm
  buildYlSearchForm: function buildYlSearchForm(el) {
    var list = this.buildAction(el.__on__, el);
    if (el.load != undefined || el.load != null) {
      list.push(":load=".concat(el.load));
    }
    return Object.assign(this.publicAttr(el), {
      dynamic: list.join(" ")
    });
  },
  //获取yl-card
  buildYlCard: function buildYlCard(el, layouts, children) {
    var config = el.__config__;
    var list = [];
    var child = this.buildChildren(layouts, children);
    list.push(":title='".concat(config.target, "Title'"));
    return Object.assign(this.publicAttr(el), {
      dynamic: list.join(""),
      child: child.join("\n")
    });
  },
  //获取yl-array-object
  buildYlArrayObject: function buildYlArrayObject(el, layouts, children) {
    var child = this.buildChildren(layouts, children.__config__.children);
    return Object.assign(this.publicAttr(el), {
      child: child
    });
  },
  //获取el-tabs
  buildElTabs: function buildElTabs(el, layouts) {
    var child = this.buildElTabsPane(el, layouts);
    var list = this.buildAction(el.__on__, el);
    if (el.__config__["class"]['low-tabs-title']) {
      list.push("class=\"low-tabs-title\"");
    }
    return Object.assign(this.publicAttr(el), {
      type: el.type,
      vmodel: "v-model='".concat(el.__config__.target, "'"),
      child: child.join("\n"),
      dynamic: list.join(" ")
    });
  },
  // el-tabs子级
  buildElTabsPane: function buildElTabsPane(scheme, layouts) {
    var _this = this;
    var children = [];
    var slot = scheme.__slot__.list;
    if (slot && slot.length > 0) {
      slot.forEach(function (item, index) {
        children.push("<el-tab-pane :label=\"".concat(scheme.__config__.target, "Label.tab").concat(index, "\" name=\"").concat(item.name, "\">\n                    ").concat(_this.buildChildren(layouts, item.list).join("\n"), "\n                </el-tab-pane>"));
      });
    }
    return children;
  },
  //获取el-collapse
  buildElCollapse: function buildElCollapse(el, layouts) {
    var child = this.buildElCollapsePane(el, layouts);
    var list = this.buildAction(el.__on__, el);
    if (el.accordion) {
      list.push("accordion");
    }
    return Object.assign(this.publicAttr(el), {
      type: el.accordion,
      vmodel: "v-model='".concat(el.__config__.target, "'"),
      child: child.join("\n"),
      dynamic: list.join(" ")
    });
  },
  // el-collapse-item子级
  buildElCollapsePane: function buildElCollapsePane(scheme, layouts) {
    var _this2 = this;
    var children = [];
    var config = scheme.__config__;
    var slot = scheme.__slot__.list;
    if (slot && slot.length > 0) {
      slot.forEach(function (item, index) {
        children.push("<el-collapse-item title=\"".concat(item.label, "\" name=\"").concat(item.name, "\" v-if=\"").concat(config.target).concat(index, "Display\" :disabled=").concat(config.target).concat(index, "Disabled>\n                    ").concat(_this2.buildChildren(layouts, item.list).join("\n"), "\n                </el-collapse-item>"));
      });
    }
    return children;
  },
  //获取yl-table
  buildYlTable: function buildYlTable(el, layouts, children) {
    var list = this.buildAction(el.__on__, el);
    // let list = [];
    if (el.hidePage) {
      list.push(":hidePage=true");
    }
    var child = this.buildChildren(layouts, children, el);
    return Object.assign(this.publicAttr(el), {
      data: "".concat(el.__config__.target, "Data"),
      dynamic: list.join(""),
      child: child.join('\n')
    });
  },
  //获取yl-dialog
  buildYlDialog: function buildYlDialog(el, layouts, children) {
    var config = el.__config__;
    var child = this.buildChildren(layouts, children, el);
    var list = [];
    if (el.footer) {
      var _list = [];
      config.buttonList.forEach(function (item, index) {
        if (!item.isDisabled) {
          item.isDisabled = {
            isAction: true,
            status: false,
            body: ""
          };
        }
        var disabledBody = item.isDisabled.body && item.isDisabled.body.includes('scope') ? _main["default"].replaceChars(item.isDisabled.body) : "source.".concat(_main["default"].replaceChars(item.isDisabled.body));
        var targetDisabled = "".concat(item.isDisabled.isAction ? item.isDisabled.status : disabledBody);
        if (item.__on__ && item.__on__.length > 0) {
          item.__on__.forEach(function (child) {
            var event = child.method.length > 0 && child.method[0] != 0 ? "@click.native=\"".concat(child.eventName).concat(config.target, "Method").concat(child.method[child.method.length - 1], "\"") : "";
            _list.push("\n                            <yl-lc-button \n                                type=\"".concat(item.type, "\" \n                                :plain=\"").concat(item.plain, "\" \n                                icon=\"").concat(item.icon, "\" \n                                name=\"").concat(item.name, "\"\n                                :disabled=\"").concat(targetDisabled, "\"\n                                ").concat(event, "\n                            >\n                            </yl-lc-button>"));
          });
        } else {
          _list.push("\n                        <yl-lc-button \n                            type=\"".concat(item.type, "\" \n                            :plain=\"").concat(item.plain, "\" \n                            icon=\"").concat(item.icon, "\" \n                            name=\"").concat(item.name, "\"\n                            :disabled=\"").concat(targetDisabled, "\"\n                        >\n                        </yl-lc-button>"));
        }
      });
      child.push("<div slot=\"footer\" class=\"text-right\">".concat(_list.join('\n'), "</div>"));
    }
    if (el.dialogTitleDate.type && el.dialogTitleDate.type != '') {
      list.push(":dialogTitleDate='".concat(JSON.stringify(el.dialogTitleDate), "'"));
    }
    return Object.assign(this.publicAttr(el), {
      dynamic: list.join(""),
      child: child.join('\n')
    });
  },
  //获取yl-form
  buildYlForm: function buildYlForm(el, tags) {
    var list = [];
    var config = el.__config__;
    config.children.forEach(function (item) {
      list.push(tags[item.__config__.tag] ? tags[item.__config__.tag](item) : null);
    });
    return Object.assign(this.publicAttr(el), {
      rowClass: el.rowClass,
      button: list.join("\n"),
      searchParmas: "".concat(config.target, "Params"),
      title: el.title,
      isShowButton: el.isShowButton,
      isShowCard: el.isShowCard,
      isSingleFormCenter: el.isSingleFormCenter,
      formButton: "".concat(config.target, "Button")
    });
  },
  //获取yl-page
  buildYlPage: function buildYlPage(el) {
    var list = this.buildAction(el.__on__, el);
    if (el.remarks) {
      list.push(":remarks='".concat(el.__config__.target, "Remark'"));
    }
    return Object.assign(this.publicAttr(el), {
      hidePage: el.hidePage,
      hideTotal: el.hideTotal,
      dynamic: list.join("")
    });
  },
  //获取yl-button
  buildYlButton: function buildYlButton(el, confGlobal) {
    var config = el.__config__;
    if (!el.dataSource) {
      el.dataSource = {
        body: el.name
      };
    }
    var textContent = _main["default"].replaceChars(el.dataSource.body);
    var list = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      list = this.buildAction(el.__on__, el, true);
    } else {
      list = this.buildAction(el.__on__, el);
    }
    if (el.type) {
      list.push("type='".concat(el.type, "'"));
    }
    if (el.name) {
      list.push("name= '".concat(el.name, "'"));
    }
    if (el.icon) {
      list.push("icon= '".concat(el.icon, "'"));
    }
    if (el.plain) {
      list.push("plain= '".concat(el.plain, "'"));
    }
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), this.displayStatusAttr(el), {
      clickMethod: "Click".concat(config.target, "Method"),
      dynamic: list.join(" "),
      vmodelDataSource: ":dataSource='".concat(config.target, "Data'"),
      scope: textContent.indexOf('scope') > -1 ? ":scope='scope'" : ''
    });
  },
  //获取el-image
  buildElImage: function buildElImage(el) {
    return Object.assign(this.publicAttr(el), {
      src: el.src ? "src=\"".concat(el.src, "\"") : ''
    });
  },
  //获取yl-formReadOnly
  buildYlFormReadOnly: function buildYlFormReadOnly(el) {
    return Object.assign(this.publicAttr(el), {
      formTitle: el.formTitle,
      title: el.title,
      isEdit: el.isEdit
    });
  },
  //获取文本div
  buildDiv: function buildDiv(el) {
    var config = el.__config__;
    var textContent = _main["default"].replaceChars(el.dataSource.body);
    return Object.assign(this.publicAttr(el), {
      defaultValue: config.defaultValue,
      vmodelDataSource: ":dataSource='".concat(config.target, "Data'"),
      scope: textContent.indexOf('scope') > -1 ? ":scope='scope'" : ''
    });
  },
  //获取文字链接
  buildElLink: function buildElLink(el) {
    var config = el.__config__;
    return Object.assign(this.publicAttr(el), {
      defaultValue: config.defaultValue,
      href: el.href,
      type: el.type,
      target: el.target,
      icon: el.icon,
      disabled: el.disabled
    });
  },
  //获取文字链接
  buildElTeps: function buildElTeps(el) {
    var config = el.__config__;
    var children = [];
    var slot = el.__slot__;
    if (slot && slot.steps && slot.steps.length) {
      slot.steps.forEach(function (item) {
        children.push("<el-step description=\"".concat(item.description, "\" status=\"").concat(item.status, "\" icon=\"").concat(item.icon, "\" title=\"").concat(item.title, "\"></el-step>"));
      });
    }
    return Object.assign(this.publicAttr(el), {
      active: el.active,
      direction: el.direction,
      simple: el.simple,
      space: el.space,
      'align-center': el['align-center'],
      'finish-status': el['finish-status'],
      'process-status': el['process-status'],
      children: children.join('\n')
    });
  },
  buildItemObject: function buildItemObject(match) {
    var list = this.arrayObjectList;
    var field = null;
    if (list) {
      list.map(function (item) {
        if (item.target == match) {
          field = "item.".concat(item.label);
        }
      });
    }
    return field;
  },
  //获取form表单
  buildElForm: function buildElForm(el, layouts, children) {
    var config = el.__config__;
    var child = this.buildChildren(layouts, children, el);
    var list = [];
    if (el['label-width']) {
      list.push("label-width='".concat(el['label-width'], "'"));
    }
    if (el['label-position']) {
      list.push("label-position='".concat(el['label-position'], "'"));
    }
    if (el.action) {
      list.push("action=\"".concat(el.action, "\""));
    }
    if (el.inline) {
      list.push(":inline=\"".concat(el.inline, "\""));
    }
    if (el['status-icon']) {
      list.push("status-icon='".concat(el['status-icon'], "'"));
    }
    list.push(":rules='".concat(config.target, "Rule' :hide-required-asterisk=\"").concat(el['hide-required-asterisk'], "\" :show-message=\"").concat(el['show-message'], "\" :inline-message='").concat(el['inline-message'], "' :validate-on-rule-change='").concat(el['validate-on-rule-change'], "' :disabled='").concat(el.disabled, "'"));
    return Object.assign(this.publicAttr(el), {
      child: child.join("\n"),
      dynamic: list.join(" ")
    });
  },
  //获取输入框
  buildElInput: function buildElInput(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var vm = this.buildItemObject(config.target);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      readonly: el.readonly,
      type: el.type,
      'prefix-icon': el['prefix-icon'],
      'suffix-icon': el['suffix-icon'],
      'show-word-limit': el['show-word-limit'],
      maxlength: el.maxlength,
      clearable: el.clearable,
      placeholder: el.placeholder,
      required: config.required,
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" ")
    });
  },
  //获取下拉框
  buildElSelect: function buildElSelect(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    if (el.remote) {
      list.push("remote");
    }
    if (el['remoteMethodName']) {
      var arg = 'query';
      if (source[0]) {
        arg += ',scope';
      }
      list.push(":remote-method = 'function(query){source.".concat(_main["default"].replaceChars(el.__config__.source.body), ".run(").concat(arg, ")}'"));
    }
    if (el.filterable) {
      list.push("filterable");
    }
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      clearable: el.clearable,
      placeholder: el.placeholder,
      required: config.required,
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" "),
      multiple: el.multiple
    });
  },
  //获取级联选择
  buildElCascader: function buildElCascader(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      clearable: el.clearable,
      'show-all-levels': el['show-all-levels'],
      filterable: el.filterable,
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" "),
      separator: el.separator,
      'collapse-tags': el['collapse-tags']
    });
  },
  //获取计数器
  buildElInputNumber: function buildElInputNumber(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      min: el.min ? ":min='".concat(el.min, "'") : '',
      max: el.max ? ":max='".concat(el.max, "'") : '',
      step: el.step ? ":step='".concat(el.step, "'") : '',
      'step-strictly': el['step-strictly'] ? 'step-strictly' : '',
      'controls-position': el['controls-position'] ? "controls-position=".concat(el['controls-position']) : '',
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" "),
      precision: el.precision ? ":precision='".concat(el.precision, "'") : ''
    });
  },
  //获取单选框
  buildElRadioGroup: function buildElRadioGroup(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      border: el.border ? "border=\"".concat(el.border, "\"") : '',
      size: el.size ? "size=\"".concat(el.size, "\"") : '',
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" ")
    });
  },
  //获取多选框
  buildElCheckboxGroup: function buildElCheckboxGroup(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      border: el.border ? "border=\"".concat(el.border, "\"") : '',
      size: el.size ? "size=\"".concat(el.size, "\"") : '',
      min: el.min ? ":min='".concat(el.min, "'") : '',
      max: el.max ? ":max='".concat(el.max, "'") : '',
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" ")
    });
  },
  //获取开关
  buildElSwitch: function buildElSwitch(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    if (el['active-text']) {
      list.push("active-text='".concat(el['active-text'], "'"));
    }
    if (el['inactive-text']) {
      list.push("inactive-text='".concat(el['inactive-text'], "'"));
    }
    if (el['active-value']) {
      list.push("active-value='".concat(el['active-value'], "'"));
    }
    if (el['inactive-value']) {
      list.push("inactive-value='".concat(el['inactive-value'], "'"));
    }
    if (el.min) {
      list.push(":min='".concat(el.min, "'"));
    }
    if (el.max) {
      list.push(":max='".concat(el.max, "'"));
    }
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" ")
    });
  },
  //获取滑块
  buildElSlider: function buildElSlider(el, elForm, confGlobal) {
    var config = el.__config__;
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    var list = this.buildAction(el.__on__, el);
    if (el.max) {
      list.push(":max='".concat(el.max, "'"));
    }
    if (el.min) {
      list.push(":min='".concat(el.min, "'"));
    }
    if (el.step) {
      list.push(":step='".concat(el.step, "'"));
    }
    list.push(":range='".concat(el.range, "' :show-stops='").concat(el['show-stops'], "' :show-input='").concat(el['show-input'], "' :show-input-controls='").concat(el['show-input-controls'], "' :show-tooltip='").concat(el['show-tooltip'], "'"));
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" ")
    });
  },
  //获取时间选择/时间范围
  buildElTimePicker: function buildElTimePicker(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    if (el.placeholder) {
      list.push("placeholder='".concat(el.placeholder, "'"));
    }
    if (el['start-placeholder']) {
      list.push("start-placeholder=\"".concat(el['start-placeholder'], "\""));
    }
    if (el['end-placeholder']) {
      list.push("end-placeholder=\"".concat(el['end-placeholder'], "\""));
    }
    if (el['range-separator']) {
      list.push("range-separator=\"".concat(el['range-separator'], "\""));
    }
    if (el['value-format']) {
      list.push("value-format=\"".concat(el['value-format'], "\""));
    }
    list.push(":is-range=\"".concat(el['is-range'], "\""));
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      format: el.format ? "format=\"".concat(el.format, "\"") : '',
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" ")
    });
  },
  //获取日期选择/日期范围
  buildElDatePicker: function buildElDatePicker(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    if (el.placeholder) {
      list.push("placeholder='".concat(el.placeholder, "'"));
    }
    if (el['start-placeholder']) {
      list.push("start-placeholder=\"".concat(el['start-placeholder'], "\""));
    }
    if (el['end-placeholder']) {
      list.push("end-placeholder=\"".concat(el['end-placeholder'], "\""));
    }
    if (el['range-separator']) {
      list.push("range-separator=\"".concat(el['range-separator'], "\""));
    }
    if (el['value-format']) {
      list.push("value-format=\"".concat(el['value-format'], "\""));
    }
    if (el.format) {
      list.push("format=\"".concat(el.format, "\""));
    }
    list.push("type=\"".concat(el.type, "\" :readonly=\"").concat(el.readonly, "\""));
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      dynamic: list.join(" "),
      formModel: "v-model='".concat(formModel, "'")
    });
  },
  //获取评分
  buildElRate: function buildElRate(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    return Object.assign(this.publicAttr(el), this.disabledStatusAttr(el), {
      max: el.max ? ":max='".concat(el.max, "'") : '',
      'allow-half': el['allow-half'] ? 'allow-half' : '',
      'show-text': el['show-text'] ? 'show-text' : '',
      'show-score': el['show-score'] ? 'show-score' : '',
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" ")
    });
  },
  //获取颜色
  buildElColorPicker: function buildElColorPicker(el, elForm, confGlobal) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    var formModel = null;
    var source = _main["default"].getComponentVmodel(el, confGlobal);
    if (source[0]) {
      formModel = "scope.row.".concat(el.targetSource);
    } else {
      formModel = "".concat(source[1]["__config__"].target, ".").concat(config.target);
    }
    return Object.assign(this.publicAttr(el), {
      disabled: "".concat(config.target, "Disabled"),
      size: "size=\"".concat(el.size, "\""),
      'show-alpha': el['show-alpha'] ? 'show-alpha' : '',
      'color-format': el['color-format'] ? "color-format=\"".concat(el['color-format'], "\"") : '',
      formModel: "v-model='".concat(formModel, "'"),
      dynamic: list.join(" ")
    });
  },
  //获取下拉菜单
  buildElDropdown: function buildElDropdown(el) {
    var list = this.buildAction(el.__on__, el);
    return Object.assign(this.publicAttr(el), {
      arg: el['split-button'] ? "type=\"primary\" split-button size=\"".concat(el.size, "\"") : "",
      dynamic: list.join(" ")
    });
  },
  //获取数据统计
  buildYlDataCensus: function buildYlDataCensus(el) {
    return Object.assign(this.publicAttr(el), {
      title: el.title ? "title=\"".concat(el.title, "\"") : "",
      titleFlag: ":titleFlag=\"".concat(el.titleFlag, "\"")
    });
  },
  //获取日历
  buildElCalendar: function buildElCalendar(el) {
    return this.publicAttr(el);
  },
  //获取上传
  buildYlUpload: function buildYlUpload(el) {
    var config = el.__config__;
    var list = this.buildAction(el.__on__, el);
    return Object.assign(this.publicAttr(el), {
      disabled: ":disabled=".concat(config.target, "Disabled"),
      numLimit: el.numLimit ? "numLimit='".concat(el.numLimit, "'") : '',
      byteLimit: el.byteLimit ? "byteLimit='".concat(el.byteLimit, "'") : '',
      limit: el.limit ? ":limit='".concat(el.limit, "'") : '',
      autoUpload: el.autoUpload ? ":autoUpload='".concat(el.autoUpload, "'") : '',
      previewType: el.previewType ? "previewType='".concat(el.previewType, "'") : '',
      deleteBtn: el.deleteBtn ? ":deleteBtn='".concat(el.deleteBtn, "'") : '',
      dynamic: list.join(" "),
      uploadFile: "".concat(el.__config__.target, "File")
    });
  },
  //获取yl-echars-line
  buildYlEcharLine: function buildYlEcharLine(el) {
    return this.publicAttr(el);
  },
  //获取yl-echars-line
  buildYlEcharPie: function buildYlEcharPie(el) {
    return this.publicAttr(el);
  },
  // el-select 子级
  buildElSelectChild: function buildElSelectChild(scheme) {
    var children = [];
    var config = scheme.__config__;
    var source = '';
    if (_main["default"].replaceChars(config.source.body).indexOf("API") != -1) {
      source = "source.".concat(_main["default"].replaceChars(config.source.body), ".data");
    } else {
      source = "source.".concat(_main["default"].replaceChars(config.source.body));
    }
    var optionLabel = '';
    if (config.isCustomFieldLabel && config.sourceFieldLabel) {
      optionLabel = "".concat(config.sourceFieldLabel);
    } else {
      optionLabel = "\"item.".concat(config.fieldLabel, "\"");
    }
    children.push("<el-option v-for=\"(item, index) in ".concat(source, "\" :key=\"index\" :label=").concat(optionLabel, " :value=\"item.").concat(config.fieldCode, "\" :disabled=\"item.disabled\"></el-option>"));
    return children.join('\n');
  },
  // el-radio-group 子级
  buildElRadioGroupChild: function buildElRadioGroupChild(scheme) {
    var children = [];
    var slot = scheme.__slot__;
    var config = scheme.__config__;
    if (slot && slot.options && slot.options.length) {
      var tag = config.optionType === 'button' ? 'el-radio-button' : 'el-radio';
      var border = scheme.border ? 'border' : '';
      children.push("<".concat(tag, " v-for=\"(item, index) in ").concat(scheme.__config__.target, "\" :key=\"index\" :label=\"item.value\" :disabled=\"item.disabled\" ").concat(border, ">{{item.label}}</").concat(tag, ">"));
    }
    return children.join('\n');
  },
  // el-checkbox-group 子级
  buildElCheckboxGroupChild: function buildElCheckboxGroupChild(scheme) {
    var children = [];
    var slot = scheme.__slot__;
    var config = scheme.__config__;
    if (slot && slot.options && slot.options.length) {
      var tag = config.optionType === 'button' ? 'el-checkbox-button' : 'el-checkbox';
      var border = config.border ? 'border' : '';
      children.push("<".concat(tag, " v-for=\"(item, index) in ").concat(scheme.__config__.target, "\" :key=\"index\" :label=\"item.value\" :disabled=\"item.disabled\" ").concat(border, ">{{item.label}}</").concat(tag, ">"));
    }
    return children.join('\n');
  },
  //el-dropdown 下拉菜单标题
  buildDropdownTitle: function buildDropdownTitle(scheme) {
    var title = scheme.__slot__.title;
    var icon = scheme['split-button'] ? "" : "<i class=\"el-icon-arrow-down el-icon--right\"></i>";
    return ["<span class=\"el-dropdown-link\">".concat(title).concat(icon, "</span>")].join('\n');
  },
  //el-dropdown 下拉菜单 菜单项
  buildDropdownMenu: function buildDropdownMenu(scheme) {
    var list = [];
    list.push("<el-dropdown-item v-for=\"(item,index) in ".concat(scheme.__config__.target, "\" :disabled=\"item.disabled\" :divided=\"item.divided\">{{item.title}}</el-dropdown-item>"));
    return list.join('\n');
  },
  //yl-lc-tree 树形控件
  buildYlTree: function buildYlTree(el) {
    var list = this.buildAction(el.__on__, el);
    return Object.assign(this.publicAttr(el), {
      treeData: ":treeData=\"".concat(el.__config__.target, "Data\""),
      'empty-text': el['empty-text'] ? ":empty-text=\"".concat(el['empty-text'], "\"") : '',
      'render-after-expand': ":render-after-expand=\"".concat(el['render-after-expand'], "\""),
      'highlight-current': ":highlight-current=\"".concat(el['highlight-current'], "\""),
      'default-expand-all': ":default-expand-all=\"".concat(el['default-expand-all'], "\""),
      'expand-on-click-node': ":expand-on-click-node=\"".concat(el['expand-on-click-node'], "\""),
      'check-on-click-node': ":check-on-click-node=\"".concat(el['check-on-click-node'], "\""),
      'auto-expand-parent': ":auto-expand-parent=\"".concat(el['auto-expand-parent'], "\""),
      'show-checkbox': ":show-checkbox=\"".concat(el['show-checkbox'], "\""),
      accordion: ":accordion=\"".concat(el.accordion, "\""),
      indent: el.indent ? ":indent='".concat(el.indent, "'") : 'indent="16"',
      "icon-class": el['icon-class'] ? "icon-class='".concat(el['icon-class'], "'") : '',
      dynamic: list.join(" ")
    });
  },
  //yl-lc-icon 图标
  buildYlIcon: function buildYlIcon(el) {
    var list = this.buildAction(el.__on__, el);
    list.push(":iconClass='".concat(el.__config__.target, "Data' :style='").concat(el.__config__.target, "Style'"));
    return Object.assign(this.publicAttr(el), {
      dynamic: list.join(" ")
    });
  },
  //el-alert
  buildElAlert: function buildElAlert(el) {
    var list = this.buildAction(el.__on__, el);
    if (el.center) {
      list.push("center");
    }
    if (el.closable) {
      list.push("closable");
    }
    if (el['show-icon']) {
      list.push("show-icon");
    }
    return Object.assign(this.publicAttr(el), {
      dynamic: list.join(" ")
    });
  }
};
exports["default"] = _default;